import api, {handleAPIErrors} from 'shared/api'

const FETCH_REQUEST = 'boardPolicies/FETCH_REQUEST'
const FETCH_SUCCESS = 'boardPolicies/FETCH_SUCCESS'
const FETCH_FAILURE = 'boardPolicies/FETCH_FAILURE'
const FETCH_RESULT_REQUEST = 'boardPolicies/FETCH_RESULT_REQUEST'
const FETCH_RESULT_SUCCESS = 'boardPolicies/FETCH_RESULT_SUCCESS'
const FETCH_RESULT_FAILURE = 'boardPolicies/FETCH_RESULT_FAILURE'

const initialState = {
    result: {
        current_year: {},
        previous_year: {}
    },
    sectorResult: {
        tableData: {},
        chartData: {}
    },
    resultLoading: false,
    resultLoaded: false,
    loading: false,
    loaded: false,
    errors: {}
}

export function fetchRequest() {
    return {
        type: FETCH_REQUEST,
    }
}

export function fetchSuccess(payload) {
    return {
        type: FETCH_SUCCESS,
        payload,
    }
}

export function fetchFailure(errors) {
    return {
        type: FETCH_FAILURE,
        errors,
    }
}

export function fetchResultRequest() {
    return {
        type: FETCH_RESULT_REQUEST,
    }
}

export function fetchResultSuccess(payload) {
    return {
        type: FETCH_RESULT_SUCCESS,
        payload,
    }
}

export function fetchResultFailure(errors) {
    return {
        type: FETCH_RESULT_FAILURE,
        errors,
    }
}

export function searchPolicy(options, cb = null) {
    return (dispatch) => {
        dispatch(fetchRequest())

        return api(`api/v1/board_policies`, options)
            .then(response => response.json().then(json => ({json, response})))
            .then(({json, response}) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(fetchSuccess(json))

                if (cb) cb()
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFailure(errors))
                })
                if (cb) cb()
            })
    }
}

export function updateResult(options = {}, cb = null) {
    const config = {
        method: 'PATCH',
        body: JSON.stringify(options)
    }

    return (dispatch) => {
        dispatch(fetchResultRequest())

        return api(`api/v1/board_policies/sector_analysis`, {}, config)
            .then(response => response.json().then(json => ({json, response})))
            .then(({json, response}) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(fetchResultSuccess(json))

                if (cb) cb()
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchResultFailure(errors))
                })
            })
    }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
    const {payload, type, errors} = action

    switch (type) {
        case FETCH_REQUEST:
            return Object.assign({}, state, {
                loading: true
            })
        case FETCH_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                loaded: true,
                errors: [],
                result: payload
            })
        case FETCH_FAILURE:
            return {
                ...state,
                loading: false,
                loaded: true,
                errors: errors
            }
        case FETCH_RESULT_REQUEST:
            return Object.assign({}, state, {
                resultLoading: true
            })
        case FETCH_RESULT_SUCCESS:
            return Object.assign({}, state, {
                resultLoading: false,
                resultLoaded: true,
                errors: [],
                sectorResult: payload
            })
        case FETCH_RESULT_FAILURE:
            return {
                ...state,
                resultLoading: false,
                resultLoaded: true,
                errors: errors
            }
        default:
            return state
    }
}

